<template>
    <tr class="item-row">
        <td class="delete" v-if="!readonly" @click.prevent="remove"><i class="fa fa-trash-o" aria-hidden="true"></i> <button class="btn">Löschen</button></td>
        <td><img :src="item.image"></td>
        <td>{{ item.model }}</td>
        <td><a :href="url">{{ item.name }}</a>
        <template v-if="item.options.address">
            <br>
            <small>
                {{item.options.address.company}}, {{item.options.address.street}}, {{item.options.address.zip}} {{item.options.address.city}}, {{item.options.address.countryName}}
            </small>
        </template>
        </td>
        <td class="text-right" title="Einzelpreis">€ {{ numberFormat }}</td>
        <td title="Stück">
            <div class="cart-row-quantity">
                <template v-if="readonly">{{ qty }}</template>
                <select v-else class="form-control select-qty" name="qty" v-model="qty" @change="updateQty" @input="updateQty">
                    <template v-for="i in item.stepSelect">
                        <option :value="i">{{i}}</option>
                    </template>
                </select>
                <span class="text-danger" v-if="item.oldQty">Alte Anzahl: {{item.oldQty}}</span>
            </div>
        </td>
        <td class="text-right" title="Subtotal">€ {{ subtotal }}</td>
    </tr>
</template>

<style lang="scss">
    .cart-row-quantity {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
</style>

<script>
export default {

    props: {
        item: {
            required: true
        },
        value: {
            type: [String, Number],
            default: 1,
        },
        stock: {
            type: [String, Number],
            required: true,
            default: null
        },
        readonly: {
            default: false
        }
    },

    data() {
        return {
            qty: null,
            loading: false,
            removing: false,
            initialized: false,
            oldQty: null
        }
    },

    watch: {
        qty:function(newValue, oldValue){
            if (oldValue == null) {
                this.oldQty = newValue;
            } else {
                this.oldQty = oldValue;
            }
        }
    },


    created() {
        this.qty = this.value;
        this.$emit('change', this.qty);
    },

    methods: {

        updateQty() {
            if(this.qty < 1) {
                this.qty = 1;
            }

            // Prevent update on first load.
            if (this.initialized) {
                this.loading = true;
                new Form({rowId: this.item.rowId, qty:this.qty})
                .post('/api/cart/update')
                .then((response) => {
                    if(response.success !== false) {
                        App.event.fire('cart.updated', response);
                        this.loading = false;
                        this.oldQty = this.qty;
                    } else {
                        this.qty = this.oldQty;

                        swal({ 
                            html:true, 
                            title:'', 
                            text: response.error_text,
                            type: "error"
                        });
                    }
                });
            }
            this.initialized = true;
        },

        remove() {
            this.removing = true;
            new Form({rowId: this.item.rowId})
            .post('/api/cart/remove')
            .then((response) => {
                App.event.fire('cart.updated', response);
                this.removing = false;
            });
        }

    },

    computed: {

        numberFormat() {
            let val = parseFloat(this.item.orgPrice).toFixed(2);
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        subtotal() {
            let val = parseFloat(this.item.orgPrice*this.item.qty).toFixed(2);
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        removeIcon() {
            return this.removing ? 'fa fa-spinner fa-spin' : 'fa fa-times';
        },

        url() {
            return '/product/'+this.item.seo;
        }
    }


}
</script>
